import { render, staticRenderFns } from "./AlertBottom.vue?vue&type=template&id=2e2aa4f3"
import script from "./AlertBottom.vue?vue&type=script&lang=js"
export * from "./AlertBottom.vue?vue&type=script&lang=js"
import style0 from "./AlertBottom.vue?vue&type=style&index=0&id=2e2aa4f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports